import { render, staticRenderFns } from "./rushAnswer.vue?vue&type=template&id=4b235a82&scoped=true&"
import script from "./rushAnswer.vue?vue&type=script&lang=js&"
export * from "./rushAnswer.vue?vue&type=script&lang=js&"
import style0 from "./rushAnswer.vue?vue&type=style&index=0&id=4b235a82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b235a82",
  null
  
)

export default component.exports